import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { DokumentService } from '../dokument.service';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { Dokument } from '../dokument.model';

@Component({
  selector: 'app-dokument-result',
  imports: [
    TableRowDirective,
    TableModule,
    DatePipe,
    KeepScrollPositionDirective,
    CprNummerPipe,
  ],
  templateUrl: './dokument-result.component.html',
  styleUrl: './dokument-result.component.css',
})
export class DokumentResultComponent {
  dokService = inject(DokumentService);
  data = this.dokService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.dokService.selectDokumentResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.dokService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }

  async visDokument(dokument: Dokument, event: MouseEvent) {
    event.stopPropagation();
    await this.dokService.hentDokument(dokument, false);
  }
}
